import { __extends } from "tslib";
import { DeleteBucketAnalyticsConfigurationRequest } from "../models/index";
import { deserializeAws_restXmlDeleteBucketAnalyticsConfigurationCommand, serializeAws_restXmlDeleteBucketAnalyticsConfigurationCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteBucketAnalyticsConfigurationCommand = /** @class */ (function (_super) {
    __extends(DeleteBucketAnalyticsConfigurationCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteBucketAnalyticsConfigurationCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteBucketAnalyticsConfigurationCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: DeleteBucketAnalyticsConfigurationRequest.filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteBucketAnalyticsConfigurationCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlDeleteBucketAnalyticsConfigurationCommand(input, context);
    };
    DeleteBucketAnalyticsConfigurationCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlDeleteBucketAnalyticsConfigurationCommand(output, context);
    };
    return DeleteBucketAnalyticsConfigurationCommand;
}($Command));
export { DeleteBucketAnalyticsConfigurationCommand };
//# sourceMappingURL=DeleteBucketAnalyticsConfigurationCommand.js.map